:host {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: $size-radius-xxs;
}

label {
  display: block;
}

.disabled {
  color: $color-typography-typo-48;

  > smart-text {
    color: $color-typography-typo-48;
  }
}

.error {
  color: $color-action-destrutive;

  > smart-text {
    color: $color-action-destrutive;
  }
}

.select {
  width: 100%;
  text-align: left;

  padding: 10px $size-space-sm;
  border: 1px solid $color-base-gray-gray-3;
  border-radius: $size-radius-xxs;
  background-color: $color-base-brand-white;

  font-family: $font-family-primary;
  color: $color-typography-typo-88;
  font-size: $size-typography-bodytext-1;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  &:focus {
    outline: none;
    border-color: $color-base-brand-yellow;
    background-color: $color-base-brand-white;
  }
  &:hover {
    background-color: $color-base-brand-white;
  }

  &[disabled] {
    color: $color-typography-typo-48;
    border-color: $color-base-gray-gray-2;
    background-color: $color-base-gray-gray-1;

    & + smart-icon {
      cursor: default;
    }
  }

  &.error {
    border-color: $color-action-destrutive;
  }
}

.dropdown-options {
  position: absolute;
  right: 0;
  left: 0;
  top: 49px;
  z-index: 10;

  display: flex;
  flex-direction: column;
  max-height: 50vh;
  overflow-y: auto;

  list-style: none;
  padding: 0;
  margin: 0;

  border-radius: $size-radius-xxs;
  border: 2px solid $color-base-gray-gray-3;
  background-color: $color-base-brand-white;
  box-shadow: 0px 0px 8px 0px rgba(160, 160, 167, 0.16);

  li:hover {
    background-color: $color-action-alert-pastel;
  }

  &--label {
    top: 77px;
  }
}

button {
  width: 100%;
  margin: 0;
  padding: 0;

  text-align: left;
  border: none;
  background-color: $color-base-brand-white;

  font-family: $font-family-primary;
  color: $color-typography-typo-88;
  font-size: $size-typography-bodytext-1;
  padding: 10px $size-space-sm;

  &:hover {
    background-color: $color-action-alert-pastel;
  }
  &:focus {
    outline: none;
    background-color: $color-action-alert-pastel;
  }
}

span {
  font-family: $font-family-primary;
  font-size: $size-typography-caption;
  line-height: $size-line-height-caption;
  color: $color-typography-typo-48;

  &.error {
    color: $color-action-destrutive;
  }
}
